import { gql } from '@apollo/client';

export const GET_ALL_IN_PROGRESS_QUIZZES_FOR_USER = gql(/*GraphQL*/ `
  query getAllInProgressQuizzesForUser {
    getAllInProgressQuizzesForUser {
        id
      userId
      userQuestions {
        questionId  
        question {
          id
          prompt
          explanation
          tag
          options {
            desc
            isAnswer
          }
        }
        selectedOption {
          desc
          isAnswer
        }
      }
      isCompleted
      completedAt
      tag
      createdAt
      updatedAt
    }
  }
`);
